import React from "react";
import {
  Input,
  Button,
  Space,
  Row,
  Col,
  Dropdown,
  Checkbox,
  Modal,
  Select,
  Image,
  Tree,
  Tooltip,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import { PlusOutlined, DownOutlined, CarOutlined, CloseOutlined } from "@ant-design/icons";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import kebabIcon from "../assets/images/NewDesign/kebab.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import withRouter from "../withRouter";

import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import GeofencesStore from "../store/GeofencesStore";
import { MapContainer, Popup, Circle, Polygon, Rectangle } from "react-leaflet";
import ReactLeafletGoogleLayer from "react-leaflet-google-layer";

import conf from "../config";
import AssignVehiclesToGeofence from "./AssignVehiclesToGeofence";
import AssignVehiclesToGeofenceStore from "../store/AssignVehiclesToGeofenceStore";
import { is } from "date-fns/locale";

dayjs.extend(customParseFormat);
const { Option } = Select;

const treeData = {
  companyId: "13",
  name: "Starling Project Testing Vehicles",
  type: "company",
  mtype: "fleet.model.CompanyTreeModel",
  children: [
    {
      text: "Sales",
      deviceGroupId: 33,
      type: "deviceGroup",
      zoneId: "7313",
      checked: false,
      mtype: "fleet.model.DeviceGroupTreeModel",
      leaf: false,
      children: [],
    },
    {
      text: "Technical",
      deviceGroupId: 34,
      type: "deviceGroup",
      zoneId: "7313",
      checked: false,
      mtype: "fleet.model.DeviceGroupTreeModel",
      leaf: false,
      children: [
        {
          text: "G30858 - FM1120/Toyota Yaris",
          vehicleId: 1589,
          deviceGroupId: 34,
          leaf: "true",
          mtype: "fleet.model.VehicleTreeModel",
          checked: false,
        },
      ],
    },
    {
      text: "All Vehicle",
      deviceGroupId: 53,
      type: "deviceGroup",
      zoneId: "7313",
      checked: false,
      mtype: "fleet.model.DeviceGroupTreeModel",
      leaf: false,
      children: [],
    },
    {
      text: "PMIS",
      deviceGroupId: 139,
      type: "deviceGroup",
      zoneId: "7313",
      checked: false,
      mtype: "fleet.model.DeviceGroupTreeModel",
      leaf: false,
      children: [
        {
          text: "TEST_ITC_TRACE5_LTE",
          vehicleId: 219030,
          deviceGroupId: 139,
          leaf: "true",
          mtype: "fleet.model.VehicleTreeModel",
          checked: false,
        },
        {
          text: "Test GS10 China",
          vehicleId: 101425,
          deviceGroupId: 139,
          leaf: "true",
          mtype: "fleet.model.VehicleTreeModel",
          checked: false,
        },
        {
          text: "FMB920_TEST",
          vehicleId: 102329,
          deviceGroupId: 139,
          leaf: "true",
          mtype: "fleet.model.VehicleTreeModel",
          checked: false,
        },
        {
          text: "E23192",
          vehicleId: 293507,
          deviceGroupId: 139,
          leaf: "true",
          mtype: "fleet.model.VehicleTreeModel",
          checked: false,
        },
        {
          text: "I44109",
          vehicleId: 293508,
          deviceGroupId: 139,
          leaf: "true",
          mtype: "fleet.model.VehicleTreeModel",
          checked: false,
        },
      ],
    },
  ],
};

// const treeData = {
//   companyId: "178",
//   name: "awtltest2",
//   type: "company",
//   mtype: "fleet.model.CompanyTreeModel",
//   children: [
//     {
//       deviceGroupId: "165",
//       text: "Test Group 1",
//       type: "deviceGroup",
//       zoneId: "64917",
//       checked: true,
//       children: [
//         {
//           text: "9958 BAA",
//           mtype: "fleet.model.VehicleTreeModel",
//           vehicleId: "20885",
//           deviceGroupId: "165",
//           leaf: "true",
//           checked: true,
//         },
//       ],
//     },
//     {
//       deviceGroupId: "208",
//       text: "Test Group 3",
//       type: "deviceGroup",
//       zoneId: "64917",
//       checked: true,
//       children: [
//         {
//           text: "4165 ARA",
//           mtype: "fleet.model.VehicleTreeModel",
//           vehicleId: "40175",
//           deviceGroupId: "208",
//           leaf: "true",
//           checked: true,
//         },
//         {
//           text: "4693 RBA",
//           mtype: "fleet.model.VehicleTreeModel",
//           vehicleId: "40244",
//           deviceGroupId: "208",
//           leaf: "true",
//           checked: true,
//         },
//       ],
//     },

//     {
//       text: "Test Plate2",
//       mtype: "fleet.model.VehicleTreeModel",
//       vehicleId: "33614",
//       leaf: "true",
//       checked: false,
//     },
//     {
//       text: "ruptela-test",
//       mtype: "fleet.model.VehicleTreeModel",
//       vehicleId: "35209",
//       leaf: "true",
//       checked: false,
//     },
//     {
//       text: "1234",
//       mtype: "fleet.model.VehicleTreeModel",
//       vehicleId: "44717",
//       leaf: "true",
//       checked: false,
//     },
//     {
//       text: "GS900",
//       mtype: "fleet.model.VehicleTreeModel",
//       vehicleId: "54553",
//       leaf: "true",
//       checked: false,
//     },
//     {
//       text: "81691",
//       mtype: "fleet.model.VehicleTreeModel",
//       vehicleId: "79638",
//       leaf: "true",
//       checked: false,
//     },
//     {
//       text: "Ruptela Test",
//       mtype: "fleet.model.VehicleTreeModel",
//       vehicleId: "101328",
//       leaf: "true",
//       checked: false,
//     },
//     {
//       text: "iridium-test",
//       mtype: "fleet.model.VehicleTreeModel",
//       vehicleId: "101885",
//       leaf: "true",
//       checked: false,
//     },
//     {
//       text: "Pioneerx10",
//       mtype: "fleet.model.VehicleTreeModel",
//       vehicleId: "101904",
//       leaf: "true",
//       checked: false,
//     },
//     {
//       text: "topflytech121",
//       mtype: "fleet.model.VehicleTreeModel",
//       vehicleId: "101905",
//       leaf: "true",
//       checked: false,
//     },
//     {
//       text: "TEMPsensor",
//       mtype: "fleet.model.VehicleTreeModel",
//       vehicleId: "104612",
//       leaf: "true",
//       checked: false,
//     },
//     {
//       text: "3234343232",
//       mtype: "fleet.model.VehicleTreeModel",
//       vehicleId: "55196",
//       leaf: "true",
//       checked: false,
//     },
//     {
//       text: "test Device type",
//       mtype: "fleet.model.VehicleTreeModel",
//       vehicleId: "57029",
//       leaf: "true",
//       checked: false,
//     },
//     {
//       text: "test Device type",
//       mtype: "fleet.model.VehicleTreeModel",
//       vehicleId: "57034",
//       leaf: "true",
//       checked: false,
//     },
//     {
//       text: "Test devicetype",
//       mtype: "fleet.model.VehicleTreeModel",
//       vehicleId: "57078",
//       leaf: "true",
//       checked: false,
//     },
//     {
//       text: "fleet-test",
//       mtype: "fleet.model.VehicleTreeModel",
//       vehicleId: "57795",
//       leaf: "true",
//       checked: false,
//     },
//     {
//       text: "test123",
//       mtype: "fleet.model.VehicleTreeModel",
//       vehicleId: "57879",
//       leaf: "true",
//       checked: false,
//     },
//     {
//       text: "866069064950445",
//       mtype: "fleet.model.VehicleTreeModel",
//       vehicleId: "57891",
//       leaf: "true",
//       checked: false,
//     },
//     {
//       text: "test239",
//       mtype: "fleet.model.VehicleTreeModel",
//       vehicleId: "58102",
//       leaf: "true",
//       checked: false,
//     },
//     {
//       text: "testTempRep",
//       mtype: "fleet.model.VehicleTreeModel",
//       vehicleId: "58397",
//       leaf: "true",
//       checked: false,
//     },
//   ],
// };

class GeofencesListToAssignVehicles extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.geofenceStore = new GeofencesStore();
    this.assignVehToGeoStore = new AssignVehiclesToGeofenceStore(this);
    console.log("This is the assign vehicle geo store",this.assignVehToGeoStore);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      company_name: "",
      listUpdated: 0,
      companyId: "",
      geofenceName: "",
      opengeofenceassign:false,

      modalVisible: false,
      column: "",
      filter: "",
      showMap: false,
      company: false,
      modalInfoObj: [],
      assignVehiclesModal: false,
      selectedRowIds: [],
      zoneId: "",

      deviceGrpAndVehicles: [],
      checkedVehiclesAndGrps: [],

      selectedColumns: [
        {
          // title: 'Geofence Name',
          title: context.translate("_FLEET_REPORTS_GEOFENCELIST_GEOFENCENAME_"),
          dataIndex: "name",
          key: "name",
          width: "15%",
        },

        {
          // title: 'Creation Date',
          title: context.translate("_FLEET_REPORTS_GEOFENCELIST_CREATIONDATE_"),
          dataIndex: "createDate",
          key: "createDate",
          width: "15%",
          render: (value) => {
            if (value) {
              const formattedDateTime = dayjs(value).format(
                "DD-MM-YYYY hh:mm:ss A"
              );
              return <>{formattedDateTime}</>;
            } else {
              return <></>;
            }
          },
        },
        {
          // title: 'Geofence Type',
          title: context.translate("_GEOFENCE_TYPE_"),
          dataIndex: "type",
          key: "type",
          width: "15%",
          render: (value) => {
            if (value == 1) {
              return "Polygon";
            } else if (value == 2) {
              return "Circle";
            } else if (value == 3) {
              return "Rectangle";
            }
          },
        },
        {
          // title: 'Customer Type',
          title: context.translate("_CUSTOMER_TYPE_"),
          dataIndex: "typeName",
          key: "typeName",
          width: "15%",
          render: (value) => {
            if (value == 1) {
              return "Retails";
            } else if (value == 2) {
              return "Food Service";
            }
          },
        },
        {
          // title: 'Bounds ',
          title: context.translate("_BOUNDS_"),
          dataIndex: "points",
          key: "points",
          width: "15%",
        },
        {
          // title: 'Radius ',
          title: context.translate("_RADIUS_"),
          dataIndex: "radius",
          key: "radius",
          width: "15%",
        },
        {
          title: context.translate("_ZONE_"),
          dataIndex: "zone",
          key: "zone",
          width: "15%",
        },
        {
          title: context.translate("_FLEET_DASHBORD_SETTING_SPEED_"),
          dataIndex: "speed",
          key: "speed",
          width: "15%",
        },
        {
          // title: 'View On Map ',
          title: context.translate("_FLEET_SERVICE_POILIST_VIEWMAP_"),
          dataIndex: "viewonmap",
          key: "viewonmap",
          width: "15%",
          align: "center",
          render: (value, obj) => {
            return (
              <Space>
                <Link
                  onClick={(e) =>
                    this.setState({ showMap: true, modalInfoObj: obj })
                  }
                >
                  {" "}
                  <img
                    src={require("../assets/images/mapIcon/gps_icon.png")}
                    style={{ height: "25px", width: "25px" }}
                  />
                </Link>

                <CarOutlined
                  style={{ fontSize: "18px" }}
                  onClick={async () => {
                    this.setState({
                      assignVehiclesModal: true,
                      zoneId: obj.zoneId,
                    });

                    const data =
                      await this.assignVehToGeoStore.getDeviceGrpAndVehicles({
                        // companyId: 13,
                        // zoneId: 5847,
                        companyId: this.state.companyId,
                        zoneId: obj.zoneId,
                        userId: this.props.getUserData().userId,
                        isadmin: this.props.getUserData().isadmin,
                      });
                    const { treeData, checkedKeys } = this.convertTreeData(
                      data[0]
                    );

                    // Save both treeData and checkedKeys in state
                    this.setState({
                      deviceGrpAndVehicles: data[0],
                      treeData,
                      checkedKeys,
                    });
                    await this.setState({ loadList: 1, openTree: true });
                  }}

                  // await this.setState({ deviceGrpAndVehicles: data[0] });
                  // await this.setState({ loadList: 1, openTree: true });
                />
              </Space>
            );
          },
        },
      ],
    };
    this.menuProps = {
      items: [
        {
          label: context.translate("_EXCEL_"),
          key: "excel",
          icon: <PlusOutlined />,
        },

        {
          label: context.translate("_PDF_"),
          key: "pdf",
          icon: <PlusOutlined />,
        },
      ],
      onClick: (val) => {
        let result = [];
        console.log(val);
        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

          var getData = {
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            interval: this.state.interval,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            colList: result.toString(),
          };
          if (val.key == "excel") {
            this.geofenceStore.exportExcel(getData);
          }
          if (val.key == "pdf") {
            this.geofenceStore.exportpdf(getData);
          }
        }
      },
    };
    this.newColumns = [...this.state.selectedColumns];
  }

  async componentDidMount() {
    if (Number(this.props.getUserData().isadmin) !== -1) {
      console.log(this.props.getUserData().userCompanyId);
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }
    this.setState({ pageSize: 50 });
    await this.setState({ column: this.state.selectedColumns });

    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }
  }
  async componentDidUpdate() {
    if (this.state.showMap) {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 10);
    }
  }
  async handleTableChange(pagination, filters, sorter) {
    //   console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async handleChange(comp) {
    this.setState({ company: false });
    await this.setState({ currentPage: 1, companyId: comp?.value });

    // await this.assignVehToGeoStore.getGeoZoneData(comp?.value);

    await this.handleSearch();
  }

  // async onSearch(value) {
  //     console.log(value)
  //     await this.setState({ emailId: value });
  //     this.handleSearch();
  // };

  async handleSearch() {
    this.setState({ loading: true });
    await this.geofenceStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      userId: this.props.getUserData().userId,
      isadmin: this.props.getUserData().isadmin
      
    });

    await this.setState({ listUpdated: 1 });
    this.setState({ loading: false }); //need to reload data
  }

  showData = async () => {
    console.log(this.state.company);
    if (!this.state.companyId) {
      this.setState({ company: true });
    } else {
      this.setState({ company: false });
    }
    if (this.state.companyId) {
      this.setState({ company: false });
      await this.geofenceStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        companyId: this.state.companyId,
        geofence: this.state.geofenceName,
      });
      await this.setState({ listUpdated: 1 });
    }
  };

  handleCheckboxChange = async (column) => {
    console.log(column);
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      console.log(filtered);
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      console.log("adsf");
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };

  searchInput = async (e) => {
    const value = e.target.value;

    // await this.setState({searchField:value})
    if (value.length >= 3) {
      await this.geofenceStore.loadData({
        geofence: value,
        companyId: this.state.companyId,
        userId: this.props.getUserData().userId,
        isadmin: this.props.getUserData().isadmin
      });
      await this.setState({ loadList: 1 });
    } else if (value.length === 0) {
      await this.geofenceStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        geofence: value,
        companyId: this.state.companyId,
        userId: this.props.getUserData().userId,
        isadmin: this.props.getUserData().isadmin
      });
      await this.setState({ currentPage: 1 });
    }
  };

  onSubmitAssignVehicles = () => {
    this.setState({ assignVehiclesModal: false });

    const data = {
      companyId: this.state.companyId,
      zoneId:
        this.state.selectedRowIds?.length > 0
          ? this.state.selectedRowIds
          : [this.state.zoneId],
      // companyId: 13,
      // zoneId: 5847,
      vehicleId: [],
      groupId: [],
    };

    this.state.checkedVehiclesAndGrps.forEach((key) => {
      if (key.startsWith("vehicleId-")) {
        data.vehicleId.push(key.replace("vehicleId-", ""));
      } else if (key.startsWith("groupId-")) {
        data.groupId.push(key.replace("groupId-", ""));
      }
    });

    const response = this.assignVehToGeoStore.assignVehiclesAndGrps(data);
  };

  convertTreeData = (data) => {
    const checkedKeys = [];
    const result = {
      title: data.name,
      key: `company-${data.companyId}`,
      children: [],
    };

    // Process children
    data.children.forEach((child) => {
      if (child.type === "deviceGroup") {
        const groupNode = {
          title: child.text,
          key: `groupId-${child.deviceGroupId}`,
          children: [],
        };

        if (child.checked) {
          checkedKeys.push(groupNode.key);
        }

        child.children?.forEach((vehicle) => {
          const vehicleKey = `vehicleId-${vehicle.vehicleId}`;

          groupNode.children.push({
            title: vehicle.text,
            key: `vehicleId-${vehicle.vehicleId}`,
            isLeaf: true,
            checked: vehicle.checked,
          });

          if (vehicle.checked === true || vehicle.checked === "true") {
            checkedKeys.push(vehicleKey);
          }
        });

        result.children.push(groupNode);
      } else {
        const vehicleKey = `vehicleId-${child.vehicleId}`;
        // vehicle without group
        result.children.push({
          title: child.text,
          key: `vehicleId-${child.vehicleId}`,
          isLeaf: true,
          checked: child.checked,
        });
        if (child.checked === true || child.checked === "true") {
          checkedKeys.push(vehicleKey);
        }
      }
    });

    return {
      treeData: [result],
      checkedKeys,
    };
  };

  onCheck = (checkedKeys, info) => {
    this.setState({
      checkedVehiclesAndGrps: checkedKeys,
      checkedKeys: checkedKeys,
    });
  };

    closeModal = () => {
    this.setState({ assignVehiclesModal: false, driverId: "" });
  };
  

  render() {
    const mapData = this.state.modalInfoObj.points?.split(",0,").map((val) => {
      return val.split(",").map((val) => Number(val));
    });

    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={(value) => this.handleChange(value)}
                  style={{ width: 150 }}
                  status={this.state.company ? "error" : false}
                />
                <Input
                  value={this.state.geofenceName}
                  style={{ width: 400, borderRadius: "25px" }}
                  placeholder={this.context.translate(
                    "_SEARCH_BY_GEOFENCE_NAME_"
                  )}
                  onChange={(e) => {
                    this.setState({ geofenceName: e.target.value });
                    this.searchInput(e);
                  }}
                />
              </Space>
            </Col>
            <Col
              span={8}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      alignItems: "center",
                      cursor: "pointer",
                      marginInlineEnd: "20px",
                    }}
                    src={refreshIcon}
                    onClick={() => this.handleSearch()}
                  ></Image>
                </Tooltip>

                {/* <Dropdown
                  overlayClassName="export-dropdown"
                  menu={this.menuProps}
                >
                  <Image
                    style={{
                      height: 18,
                      alignItems: "center",
                      cursor: "pointer",
                      marginInlineEnd: "20px",
                    }}
                    src={downloadIcon}
                  ></Image>
                </Dropdown> */}
                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {/* Columns */}
                  {this.context.translate("_COLUMNS_")}
                </Button>
                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.geofenceStore?.geofencesReport?.length > 0 ? false : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.menuProps}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>

                

                {/* <Link to="/assignVehicleToGeofence"> */}
                {this.props.getUserData().isadmin !== 0 && (
                  <Button
                    className="addButtonClass"
                    onClick={async () => {
                      this.state.selectedRowIds.length > 0
                        ? this.setState({ assignVehiclesModal: true })
                        : Modal.warning({
                            title: this.context.translate("_FLEET_ALERT_"),
                            content: this.context.translate(
                              "_PLEASE_SELECT_GEOFENCE_"
                            ),
                            style: {
                              padding: "20px !important",
                              borderRadius: "10px",
                            },
                          });
                      const data =
                        await this.assignVehToGeoStore.getDeviceGrpAndVehicles({
                          companyId: this.state.companyId,
                          zoneId: this.state.selectedRowIds,
                          userId: this.props.getUserData().userId,
                          isadmin: this.props.getUserData().isadmin,
                        });
                      const { treeData, checkedKeys } = this.convertTreeData(
                        data[0]
                      );

                      this.setState({
                        deviceGrpAndVehicles: data[0],
                        treeData,
                        checkedKeys,
                      });
                      await this.setState({ loadList: 1, openTree: true });
                    }}
                  >
                    <Image
                      style={{ marginInlineEnd: "5px", width: 13 }}
                      src={require("../assets/images/NewDesign/plus (Stroke).png")}
                    ></Image>
                  {this.context.translate("_ASSIGN_")}
                  </Button>
                )}
              </Space>
            </Col>
          </Row>



          <Modal
            open={this.state.modalVisible}
            width={300}
            // title="Select Columns"
            title={this.context.translate("_SELECT_COLUMNS_")}
            onCancel={() => this.setState({ modalVisible: false })}
            onOk={() => {
              this.setState({ modalVisible: false });
            }}
            footer={null}
          >
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {this.newColumns.map((column, v) => {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </Modal>

          <ListTable
            rowKey="zoneId"
            rowSelection={{
              onChange: async (selectedRowKeys, selectedRows) => {
                console.log(selectedRowKeys, selectedRows);
                this.setState({ selectedRowIds: selectedRowKeys });
              },
            }}
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.geofenceStore?.total}
            columns={this.state.column}
            dataSource={this.geofenceStore?.geofencesReport}
            loading={this.geofenceStore?.loading}
            onChange={this.handleTableChange}
            // scroll={{
            //   // y: this.state.clientHeight-240,
            //   x: 100,
            // }}
          />

          {this.state.showMap && (
            <Modal
              // title="Geofence on Map"
              title={this.context.translate("_FLEET_GEOFENCE_REPORT_")}
              open={this.state.showMap}
              centered
              // bodyStyle={{ height: 1000 }}
              width={850}
              height={400}
              onOk={() => this.setState({ showMap: false })}
              onCancel={() => this.setState({ showMap: false })}
              footer={false}
            >
              {this.state.modalInfoObj?.points?.length > 2 ? (
                <MapContainer
                  ref={this.mapRef}
                  zoom={15.3}
                  // center={[24.7136, 46.6753]}
                  center={[
                    this.state.modalInfoObj?.points?.split(",")[0] ||
                      conf.mapCenter,
                    this.state.modalInfoObj?.points?.split(",")[1] ||
                      conf.mapCenter,
                  ]}
                  style={{ height: "400px", width: "800px" }}
                  zoomControl={false}
                >
                  <ReactLeafletGoogleLayer />

                  {this.state.modalInfoObj?.points &&
                    this.state.modalInfoObj?.type == 1 && (
                      <Polygon
                        // positions={this.state.modalInfoObj?.points}
                        positions={mapData}
                        pathOptions={{ color: "red" }}
                      >
                        <Popup>{this.state.modalInfoObj?.name}</Popup>
                      </Polygon>
                    )}

                  {this.state.modalInfoObj?.type == 2 &&
                    this.state.modalInfoObj?.points && (
                      <Circle
                        center={{
                          lat:
                            this.state.modalInfoObj?.points.split(",")[0] || 0,
                          lng:
                            this.state.modalInfoObj?.points.split(",")[1] || 0,
                        }}
                        radius={this.state.modalInfoObj?.radius}
                        pathOptions={{ color: "red" }}
                      >
                        <Popup>{this.state.modalInfoObj?.name}</Popup>
                      </Circle>
                    )}

                  {this.state.modalInfoObj?.type == 3 &&
                    this.state.modalInfoObj?.points && (
                      <Rectangle
                        bounds={mapData}
                        pathOptions={{ color: "red" }}
                      ></Rectangle>
                    )}
                </MapContainer>
              ) : (
                <MapContainer
                  ref={this.mapRef}
                  zoom={15.3}
                  // center={[24.7136, 46.6753]}
                  center={conf.mapCenter}
                  style={{ height: "400px", width: "800px" }}
                  zoomControl={false}
                >
                  <ReactLeafletGoogleLayer />
                </MapContainer>
              )}
            </Modal>
          )}

          {/* <Modal
            title={this.context.translate("_FLEET_USER_USERLIST_VEHICLE_")}
            open={this.state.assignVehiclesModal}
            centered
            width={600}
            onOk={() => this.setState({ assignVehiclesModal: false })}
            onCancel={() => this.setState({ assignVehiclesModal: false })}
            footer={false}
          >
            <div style={{ height: "500px", overflow: "auto" }}>
              <AssignVehiclesToGeofence
                zoneId={this.state.selectedRowIds || this.state.zoneId}
                companyId={this.state.companyId}
              />
            </div>
          </Modal> */}

          {this.state.assignVehiclesModal && (
            <Drawer
              className="uploadExcelDrawer"
              width={716}
              closeIcon={false}
              open={this.state.assignVehiclesModal}
              placement={
                this.context.locale.language === "english" ? "right" : "left"
              }
              footer={false}
              title={
                <div className="formTitle">
                  {this.context.translate("_FLEET_USER_USERLIST_VEHICLE_")}
                  <p className="formDescription">
                    {this.context.translate("_ASSIGN_VEHICLES_TO_GEOFENCE_")}
                  </p>
                </div>
              }
              maskClosable={false}
              onClose={() => this.setState({ assignVehiclesModal: false })}
            >
              <AssignVehiclesToGeofence
                zoneId={this.state.selectedRowIds || this.state.zoneId}
                companyId={this.state.companyId}
                treeData={this.state.treeData}
                checkedKeys={this.state.checkedKeys}
                openTree={this.state.openTree}
                onCheck={this.onCheck}
                onSubmit={this.onSubmitAssignVehicles}
                closeModal={this.closeModal}
              />
            </Drawer>
          )}
        </div>
      </>
    );
  }
}
GeofencesListToAssignVehicles.contextType = StoreContext;
export default observer(withRouter(GeofencesListToAssignVehicles));